<template>
  <section class="sidebar">
    <ul class="sidebar-menu" data-widget="tree">
      <li class="header">MAIN NAVIGATION</li>
      <template v-for="(item, i) in $router.options.routes" v-if="!item.hidden">
        <li v-if="item.subMenu" class="treeview" :key="i">
          <a href="javascript:">
            <i :class="item.icon"></i> <span v-text="item.name"></span>
            <span class="pull-right-container"><i class="fa fa-angle-left pull-right"></i></span>
          </a>
          <ul class="treeview-menu">
            <template v-for="(child, i0) in item.children" v-if="!child.hidden">
              <li :key="i0"><router-link :to="child.path"><i :class="child.icon"></i> <span v-text="child.name"></span></router-link></li>
            </template>
          </ul>
        </li>
        <li v-else :key="i"><router-link :to="item.children[0].path"><i :class="item.children[0].icon"></i> <span v-text="item.children[0].name"></span></router-link></li>
      </template>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'AltSidebar',
  data () {
    return {
      header: 'MAIN NAVIGATION'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Layout/AltSidebar.vue